import React, { useState } from 'react';
import ModalWrapper from '../../common/Modal/ModalWrapper';
import Button from '../../common/Button';
import { toggleModal } from '../../../reducers/modalReducer';
import { useDispatch } from 'react-redux';
import Heading from '../../common/Heading';

const EditGroupUpdateModal = ({
    modalType,
    parentCompany,
    handleChildCompany,
    companiesGroup,
    updateGroupCompany,
    setCompaniesGroup,
    updateType,
    user,
    profileClass
}) => {
    const dispatch = useDispatch();
    const [selectedCompanies, setSelectedCompanies] = useState([]);

    const onCloseHandler = () => {
        dispatch(toggleModal({ open: "" }));
        setSelectedCompanies([]);
        setCompaniesGroup({});
    };

    const childrenCompanies = parentCompany?.childrenCompanies || [];

    const handleCheckboxChange = (event, childCompany) => {
        handleChildCompany({
            event,
            companyId: childCompany['_id'],
            group: childCompany['group'],
            percentage: childCompany['percentage'],
            selected: 'true'
        });
        if (event.target.checked) {
            setSelectedCompanies(prev => [...prev, childCompany['_id']]);
        } else {
            setSelectedCompanies(prev => prev.filter(id => id !== childCompany['_id']));
        }
    };

    return (
        <ModalWrapper modalType={modalType} onCloseHandler={onCloseHandler}>
            <div className=''>
                <Heading text={`${updateType} Group Companies`} />
                <div className='bottom-company-area' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {childrenCompanies.length > 0 ? childrenCompanies.map((childCompany, idx) => (
                        <div key={`update-child-${idx}`}
                            style={{ backgroundColor: '#F0F2FD80' }}
                            className='company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem'>
                            <span className="checkbox active w2rem h2rem pr mr0-75rem">
                                <input
                                    onChange={(event) => handleCheckboxChange(event, childCompany)}
                                    id={`updateChildCompany-${childCompany['_id']}`}
                                    className="bo5 bw2px bss cp td250 w2rem h2rem br5px"
                                    type="checkbox"
                                />
                            </span>
                            <div className="company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb">
                                <div className='df fdc jcfs aifs'>
                                    <h4 className='fs1rem mr1rem w11rem c15'>
                                        {childCompany['cName']}
                                    </h4>
                                    {childCompany['subscription']
                                        ? <h2 className="fs11px c45 mra tal w2rem">{childCompany['subscription']?.toUpperCase()}</h2>
                                        : <h2 className="fs11px c45 mra tal mra w3rem">INACTIVE</h2>
                                    }
                                </div>
                                <span className='mr0-5rem df jsc w4rem'>
                                    <div className='df w4rem jcc'>
                                        <span className='df username-area'>
                                            <div className="df aic" style={{ flexDirection: "column", alignItems: "end" }}>
                                                {childCompany?.['creatorId']?.['profile']
                                                    ? <img className={`w2rem h2rem df jcc aic br100 mr0-5rem bs4px brss bo34 ${profileClass}`} src={childCompany['creatorId']['profile']} data-tooltip={childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "")) : ""} />
                                                    : <span data-tooltip={childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "")) : ""} className={`w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem bg3 c1 ${profileClass}`}>{childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'][0] + (childCompany['creatorId']?.['lastName']?.[0] || "")) : "?"}</span>
                                                }
                                            </div>
                                        </span>
                                    </div>
                                </span>
                                <div className='dropdown-company w8rem px0-5rem py0-5rem'>
                                    <select
                                        defaultValue={childCompany['group']}
                                        disabled={updateType === "Delete"}
                                        name="dropdown"
                                        className="fs0-75rem w100 p0-5rem br5px"
                                        style={{ color: updateType === 'Delete' ? '#aeacac' : undefined }}
                                        onChange={(e) => handleChildCompany({ companyId: childCompany['_id'], group: e.target.value })}
                                        id={`group-${childCompany['_id']}`}
                                    >
                                        <option value='Subsidiary'>Subsidiary</option>
                                        <option value='Associate'>Associate</option>
                                    </select>
                                </div>
                                <div className='percentage-area ml1rem w5rem'>
                                    <span className='input-area'>
                                        <input
                                            defaultValue={childCompany['percentage'] || ''}
                                            disabled={updateType === "Delete"}
                                            onChange={(e) => handleChildCompany({
                                                companyId: childCompany['_id'],
                                                group: companiesGroup[childCompany['_id']]?.['group'] || childCompany['group'],
                                                percentage: e.target.value
                                            })}
                                            placeholder='0%'
                                            id={`percentage-${childCompany['_id']}`}
                                            type="text"
                                            className="fw600 bg1 bs1px brss bo31 br10px py0-5rem px1rem percentage w100"
                                            min="1"
                                            max="100"
                                            style={{ color: updateType === 'Delete' ? '#aeacac' : undefined }}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className='tac py2rem'>
                            <p className='c7 fs0-875rem'>No child companies in this group.</p>
                        </div>
                    )}
                </div>
                <div className='mb2rem mt3rem df jcc'>
                    <Button
                        btnType={updateType === 'Delete' ? 'dark' : 'warning'}
                        text={updateType}
                        disabled={selectedCompanies.length === 0}
                        onClick={() => updateGroupCompany(updateType)}
                    />
                </div>
            </div>
        </ModalWrapper>
    );
};

export default EditGroupUpdateModal;
